import React from 'react';
import { Modal, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

interface ShowModalProps {
    show: boolean,
    toggleShow: () => void,
    setResponse: React.Dispatch<React.SetStateAction<boolean>>
}

const ModalDelete = ({ show, toggleShow, setResponse }: ShowModalProps) => {
    const handleClose = () => {
        setResponse(false);
        toggleShow();
    }
    const handleConfirm = () => {
        setResponse(true);
        toggleShow();
    }

    return (
        <Modal
            title="Excluir"
            visible={show}
            onCancel={handleClose}
            footer={null}
            centered
            closable={true}
            bodyStyle={{ textAlign: 'center', padding: '8px'}}
            style={{ borderRadius: '8px', overflow: 'hidden' }}
        >
            <DeleteOutlined style={{ fontSize: '48px', color: '#CF1322', margin: '24px 0' }} />
            <p style={{ fontSize: '16px', fontFamily: 'Century Gothic, sans-serif' }}> 
                Tem certeza de que deseja excluir este item?
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '32px' }}>
                <Button
                    type='primary'
                    onClick={handleClose} 
                    style={{
                        width: '48%',
                        height: '40px',
                        borderRadius: '8px',
                        border: '1px solid #D9D9D9',
                        color: '#595959',
                        background: '#fff',
                        fontFamily: 'Century Gothic, sans-serif' 
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    type='primary'
                    danger
                    onClick={handleConfirm}
                    style={{
                        width: '48%',
                        height: '40px',
                        borderRadius: '8px',
                        backgroundColor: '#D22D2D',
                        border: 'none',
                        fontFamily: 'Century Gothic, sans-serif'
                    }}
                >
                    Confirmar
                </Button>
            </div>
        </Modal>
    );
};

export default ModalDelete;